<template>
  <section class="hero is-fullheight cart-page">
    <PmNavbar />

    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-4 white-bg p-5">
            <h1 class="mb-4">Vaihda salasanaa</h1>
            <label>Nykyinen salasana *</label>
            <input
              v-model="form.old_password"
              type="password"
              class="input mb-3"
              placeholder="Nykyinen salasana *"
            />
            <label>Uusi salasana *</label>
            <input
              v-model="form.new_password"
              type="password"
              class="input mb-3"
              placeholder="Uusi salasana *"
            />
            <label>Toista uusi salasana *</label>
            <input
              v-model="form.confirm_password"
              type="password"
              class="input mb-4"
              placeholder="Toista uusi salasana *"
            />

            <div v-if="errors.length" class="notification is-danger mb-4">
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>

            <button class="pyroll-button purple-bg font-white" @click="changePassword">
              Vaihda salasana
            </button>

          </div>
        </div>
      </div>
    </div>

    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import {mapActions, mapMutations} from "vuex"

export default {
  name: 'ChangePassword',
  components: {
    PmNavbar,
    PmFooter
  },
  data() {
    return {
      form: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      errors: []
    }
  },
  methods: {
    ...mapActions({
      postChangePassword: 'postChangePassword'
    }),
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
    }),
    changePassword() {
      this.errors = []

      if (!this.form.old_password) {
        this.errors.push('Vanha salasana vaaditaan')
      }

      if (!this.form.new_password) {
        this.errors.push('Uusi salasana vaaditaan')
      }

      if (!this.form.confirm_password) {
        this.errors.push('Vahvista uusi salasana')
      }

      // Password match
      if (this.form.new_password && this.form.new_password !== this.form.confirm_password) {
        this.errors.push('Salasanat eivät täsmää')
      }

      if (this.errors.length) {
        return
      }

      this.setSpinnerState(true)

      this.postChangePassword(
        {
          'old_password': this.form.old_password,
          'new_password': this.form.new_password,
          'confirm_password': this.form.confirm_password
        }
      ).then(() => {
        this.setSpinnerState(false)
        this.$router.push({name: 'Designs'})
      })
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.cart-page {
  .container {
    padding-left: 12px;
    padding-right: 12px;
  }

  .custom-black {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .amount-input {
    width: 66px;
    height: 31px;
    background-color: #DEDBD9;
  }
  .border-bottom {
    border-bottom: 1px solid #707070;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  // Remove arrows in number input type
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .mandatory-fields-text {
    color: #DEDBD9;
  }
}

span.is-clickable {
  color: $pyroll-violet;
  svg {
    width: 20px;
    height: 20px;
  }
}

.text-wrapper {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
